

export enum PackageEventOriginSource{
  WEB = "WEB",
  MOBILE = "MOBILE",
  EXTERNAL = "EXTERNAL",
}
